import React, {useCallback} from 'react';
import { Fade, Grid } from '@material-ui/core';
import clsx from 'clsx';
import { Swipeable } from 'react-swipeable';
import { useDispatch } from 'react-redux';
import CloseAction from '../actions/closeAction';
import PageSelect from '../actions/PageSelect';
import MediaDialogGroupActions from '../actions/mediaDialogGroupActions';
import { Article } from '../../../../../../types/items';
import useStyles from '../styles';
import { shouldToggleVideoPlayerInMediaViewer } from '../../../../../../store/modules/media-viewer/actions';
import { isMobileOnly } from 'react-device-detect';

type Props = {
  type?: 'desktop' | 'mobile';
  media: Article;
  onClose: () => void;
  thumbnailHandler: () => void;
  downloadHandler: () => void;
  title: string;
  show?: boolean;
  playerContainer?: { width: string; height: string };
  swipeParameters?: {
    onSwipedLeft: () => void;
    onSwipedRight: () => void;
    onSwipedUp: () => void;
    onSwipedDown: () => void;
    delta: number;
  };
};

const MediaPreviewModalHeader = ({
                                   media,
                                   onClose,
                                   title,
                                   downloadHandler,
                                   thumbnailHandler,
                                   type = 'desktop',
                                   show = true,
                                   playerContainer,
                                   swipeParameters,
                                 }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const onClickHeaderHandler = useCallback(() => {
    if (isMobileOnly) {
      dispatch(shouldToggleVideoPlayerInMediaViewer());
    }
  }, [dispatch]);

  return (
    <Fade in={show} timeout={{ enter: 0, exit: 1000 }}>
      <Grid
        container
        style={{ height: 50 }}
        className={clsx(classes.header, {
          [classes.headerMobile]: type === 'mobile',
        })}
        onClick={onClickHeaderHandler}
      >
        {type === 'mobile' && media.video_id > 0
        && (
          <Swipeable {...swipeParameters}>
            <div
              // style={{ height: playerContainer?.height ? `calc(${playerContainer.height})` : 'auto' }}
              className={classes.overlay}
            />
          </Swipeable>
        )}
        <Grid item>
          <CloseAction onClick={onClose} />
        </Grid>

        <Grid
          item
          className={clsx(classes.titleWrapper, {
            [classes.mobileTitleWrapper]: type === 'mobile',
          })}
        >
          <div className={clsx(classes.title, {
            [classes.titleMobile]: type === 'mobile',
          })}
          >
            {title}
          </div>
          <div className={clsx(classes.uploaded, {
            [classes.uploadedMobile]: type === 'mobile',
          })}
          >
            {`Uploaded ${media.ref.created_age}`}
          </div>
        </Grid>

        {type === 'mobile'
        && (
          <MediaDialogGroupActions
            media={media}
            thumbnailHandler={thumbnailHandler}
            downloadHandler={downloadHandler}
            styleType="mobile"
          />
        )}

        {type === 'desktop'
        && (
          <Grid container spacing={1} className={classes.controlsWrapper}>
            {media.ref.document?.media_type_id === 4
            && (
              <Grid item>
                <PageSelect media={media} />
              </Grid>
            )}
            <Grid item>
              <MediaDialogGroupActions
                media={media}
                thumbnailHandler={thumbnailHandler}
                downloadHandler={downloadHandler}
                styleType="desktop"
              />
            </Grid>
          </Grid>
        )}

      </Grid>

    </Fade>
  );
};

export default MediaPreviewModalHeader;
